module.exports = __webpack_public_path__ + "img/charade-true.937f8388.svg";